<form *ngIf="userPreferences">
    <h3>{{'DROPDOWN.USER_PREFERENCES.HEADER' | anessaTranslation: null}}</h3>
    <h4>{{'DROPDOWN.USER_PREFERENCES.DESCRIPTION' | anessaTranslation: null}}</h4>

    <hr>
    <h4>open project preferences</h4>

    <div class="flex-container">
        <div (mouseenter)="resetBtn.openProjDisplayCount = true"
             (mouseleave)="resetBtn.openProjDisplayCount = false"
             class="flex-box form-field-container">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{'PROJECT.OPEN.NUM_PROJ' | anessaTranslation: null}}</mat-label>
                <mat-select [(ngModel)]="userPreferences.openProjListDisplayCount"
                            (ngModelChange)="onChange(UserPreferenceProps.OPEN_PROJ_LIST_DISPLAY_COUNT, $event)"
                            id="open-proj-display-count-pref-select"
                            name="open-proj-display-count-pref-select">
                    <mat-option *ngFor="let display of openProjDisplayCountOptions"
                                [value]="display">{{ display }}</mat-option>
                    <mat-option
                            [value]="OpenProjectDisplayCountOption.ALL">{{'PROJECT.OPEN.VIEW_ALL' | anessaTranslation: null}}</mat-option>
                </mat-select>
            </mat-form-field>
            <p
                    (click)="resetInput(UserPreferenceProps.OPEN_PROJ_LIST_DISPLAY_COUNT)"
                    *ngIf="userPreferences.openProjListDisplayCount && resetBtn.openProjDisplayCount"
                    class="form-field-clear">{{'PROJECT.COMMON.RESET' | anessaTranslation: null}}</p>
        </div>

      <div (mouseenter)="resetBtn.openProjSortOrder = true"
           (mouseleave)="resetBtn.openProjSortOrder = false"
           class="flex-box form-field-container">
        <mat-form-field  appearance="outline" floatLabel="always">
          <mat-label>{{'PROJECT.OPEN.SORT_BY' | anessaTranslation: null}}</mat-label>
          <mat-select [(ngModel)]="userPreferences.openProjListSortOrder"
                      (ngModelChange)="onChange(UserPreferenceProps.OPEN_PROJ_LIST_SORT_ORDER, $event)"
                      id="open-proj-sort-preference-select"
                      name="open-proj-sort-preference-select">
            <mat-option *ngFor="let sortOption of sortOptions"
                        [value]="sortOption.value"> {{ sortOption.translationId | anessaTranslation: null}}</mat-option>
          </mat-select>
        </mat-form-field>
        <p
                (click)="resetInput(UserPreferenceProps.OPEN_PROJ_LIST_SORT_ORDER)"
                *ngIf="userPreferences.openProjListSortOrder && resetBtn.openProjSortOrder"
                class="form-field-clear">{{'PROJECT.COMMON.RESET' | anessaTranslation: null}}</p>
      </div>
    </div>

    <app-save-cancel-buttons
            (cancelClick)="closeDialog()"
            (saveClick)="savePreferences()"
            [bypassPermissions]="true"
            [styling]="'compact-button-group'"
            [enableUnsavedChangesBtn]="true"
            [unsavedChanges]="unsavedChanges"
    ></app-save-cancel-buttons>
</form>
